import { render, staticRenderFns } from "./DistributionChart.vue?vue&type=template&id=359ebe74&scoped=true"
import script from "./DistributionChart.vue?vue&type=script&lang=js"
export * from "./DistributionChart.vue?vue&type=script&lang=js"
import style0 from "./DistributionChart.vue?vue&type=style&index=0&id=359ebe74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359ebe74",
  null
  
)

export default component.exports